module.exports = __webpack_public_path__ + "static/media/sort.67476ddb.svg";